"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const setObjectPropByPath_1 = __importDefault(require("../../shared/setObjectPropByPath"));
const formatControlPropertyBeforeModify_1 = __importDefault(require("../../shared/formatControlPropertyBeforeModify"));
const modifyControl = ({ entryVars: { element: elementEntryVar, data, property, }, processor, }) => {
    var _a;
    if (typeof elementEntryVar !== 'string'
        && (typeof elementEntryVar !== 'object' || !elementEntryVar)) {
        processor.root.alert('Modify control error', 'The control to modify was not found');
        return;
    }
    const element = elementEntryVar;
    const isValidPath = (string) => /^([0-9A-Za-z-])+([.]([0-9A-Za-z-])+)*$/.test(string);
    if (property && typeof property === 'string' && isValidPath(property)) {
        const flattedControls = processor.root.getFlattedControls();
        let elementId;
        if (typeof element !== 'string') {
            if (typeof element.id !== 'string' || !element.id) {
                processor.root.alert('Modify control error', 'The control to modify was not found');
                return;
            }
            elementId = element.id;
        }
        else {
            elementId = element;
        }
        if (property.includes('extraData')) {
            const path = property.replace('extraData.', '').replace('extraData', '');
            processor.root.setControlExtraData({
                controlId: elementId,
                path: path !== '' ? path : undefined,
                data,
            });
            return;
        }
        const controlToModify = flattedControls ? (_a = flattedControls[elementId]) === null || _a === void 0 ? void 0 : _a.control : undefined;
        if (flattedControls && controlToModify) {
            const finalData = (0, formatControlPropertyBeforeModify_1.default)({
                value: data,
                controlToModify,
                propertyToModify: property,
            });
            const updatedControl = (0, setObjectPropByPath_1.default)(controlToModify, property.split('.'), finalData);
            if (updatedControl.tag === 'map' && updatedControl.region) {
                updatedControl.region = Object.assign(Object.assign({}, updatedControl.region), { isFromCallback: false });
            }
            processor.root.updateControlById({
                control: controlToModify,
                dataToUpdate: Object.assign(Object.assign({}, updatedControl), { isDynamicLoadingEnabled: false }),
            });
            // Instantaneous update
            const controlId = controlToModify.id;
            const controlInfo = flattedControls[controlId];
            if (controlInfo) {
                controlInfo.control = updatedControl;
            }
        }
        return;
    }
    throw new Error('Your property is not a valid path');
};
exports.default = modifyControl;
